import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins } from '../styles';
import { Container, Heading } from './ui';

import o2Logo from '../images/client-logos/02-logo.img.svg';
import argosLogo from '../images/client-logos/argos-logo.img.svg';
import avonLogo from '../images/client-logos/avon-logo.img.svg';
import birdseyeLogo from '../images/client-logos/birdseye-logo.img.svg';
import bupaLogo from '../images/client-logos/bupa-logo.img.svg';
import capitaLogo from '../images/client-logos/capita-logo.img.svg';
import cocacolaLogo from '../images/client-logos/cocacola-logo.img.svg';
import gskLogo from '../images/client-logos/gsk-logo.img.svg';
import lastminuteLogo from '../images/client-logos/lastminute-logo.img.svg';
import lexusLogo from '../images/client-logos/lexus-logo.img.svg';
import lloydsLogo from '../images/client-logos/lloyds-logo.img.svg';
import lorealLogo from '../images/client-logos/loreal-logo.img.svg';
import lurpakLogo from '../images/client-logos/lurpak-logo.img.svg';
import mothercareLogo from '../images/client-logos/mothercare-logo.img.svg';
import npowerLogo from '../images/client-logos/npower-logo.img.svg';
import powergenLogo from '../images/client-logos/powergen-logo.img.svg';
import rbsLogo from '../images/client-logos/rbs-logo.img.svg';
import saabLogo from '../images/client-logos/saab-logo.img.svg';
import skyLogo from '../images/client-logos/sky-logo.img.svg';
import tescoLogo from '../images/client-logos/tesco-logo.img.svg';
import thebodyshopLogo from '../images/client-logos/thebodyshop-logo.img.svg';
import toniandguyLogo from '../images/client-logos/toniandguy-logo.img.svg';

const StyledFeaturedLogos = styled.section`
  ${sectionMargins()}
`;

const StyledHeading = styled(Heading)`
  text-align: center;
`;

const StyledItems = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 30px;

  ${minBreakpointQuery.small`
    margin-top: 40px;
  `}

  ${minBreakpointQuery.medium`
    margin-top: 50px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 60px;
  `}
`;

const StyledItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 15px;
  width: 50%;

  ${minBreakpointQuery.small`
    width: calc(100% / 3);
  `}

  ${minBreakpointQuery.smedium`
    padding-top: 30px;
    padding-botom: 30px;
  `}

  ${minBreakpointQuery.medium`
    width: calc(25%);
  `}

  ${minBreakpointQuery.mlarge`
    padding-top: 40px;
    padding-botom: 40px;
  `}

  ${minBreakpointQuery.large`
    width: calc(20%);
  `}
`;

const StyledImage = styled.img`
  max-height: 60px;
  max-width: 120px;
`;

const FeaturedLogos = ({ heading }) => {
  const items = [
    {
      src: o2Logo,
      alt: '02 Logo',
    },
    {
      src: argosLogo,
      alt: 'Argos Logo',
    },
    {
      src: avonLogo,
      alt: 'Avon Logo',
    },
    {
      src: birdseyeLogo,
      alt: 'Birds Eye Logo',
    },
    {
      src: bupaLogo,
      alt: 'Bupa Logo',
    },
    {
      src: capitaLogo,
      alt: 'Capita Logo',
    },
    {
      src: cocacolaLogo,
      alt: 'Coca-Cola Logo',
    },
    {
      src: gskLogo,
      alt: 'GSK Logo',
    },
    {
      src: lastminuteLogo,
      alt: 'lastminute.com Logo',
    },
    {
      src: lexusLogo,
      alt: 'Lexus Logo',
    },
    {
      src: lloydsLogo,
      alt: 'Lloyds Logo',
    },
    {
      src: lorealLogo,
      alt: 'Loreal Logo',
    },
    {
      src: lurpakLogo,
      alt: 'Lurpak Logo',
    },
    {
      src: mothercareLogo,
      alt: 'Mothercare Logo',
    },
    {
      src: npowerLogo,
      alt: 'Npower Logo',
    },
    {
      src: powergenLogo,
      alt: 'Powergen Logo',
    },
    {
      src: rbsLogo,
      alt: 'RBS Logo',
    },
    {
      src: saabLogo,
      alt: 'Saab Logo',
    },
    {
      src: skyLogo,
      alt: 'Sky Logo',
    },
    {
      src: tescoLogo,
      alt: 'Tesco Logo',
    },
    {
      src: thebodyshopLogo,
      alt: 'The Body Shop Logo',
    },
    {
      src: toniandguyLogo,
      alt: 'Toni & Guy Logo',
    },
  ];

  return (
    <StyledFeaturedLogos>
      <Container>
        <StyledHeading>{heading}</StyledHeading>
        <StyledItems>
          {items.map(({ src, alt }, i) => (
            <StyledItem key={`featured-logo-${i}`}>
              <StyledImage src={src} alt={alt} loading="lazy" />
            </StyledItem>
          ))}
        </StyledItems>
      </Container>
    </StyledFeaturedLogos>
  );
};

export default FeaturedLogos;
